import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WalletContext } from '../../context/WalletContex';
import BottomNav from './BottomNav';
import apiClient from '../../utils/apiClient';
import { toast } from 'react-toastify';
import { HiInformationCircle, HiEnvelope } from 'react-icons/hi2';

export default function AppShell({ children }) {
  const { wallet } = useContext(WalletContext);
  const navigate   = useNavigate();

  const isGuest           = wallet && !wallet.backedUp;
  const isUnverified      = wallet?.backedUp && !wallet?.emailVerified;

  return (
    <div className="app-shell">

      {/* Strip 1: guest wallet — informational, not alarming */}
      {isGuest && (
        <div style={{
          background: 'rgba(124,92,246,0.08)',
          borderBottom: '1px solid rgba(124,92,246,0.18)',
          padding: '9px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}>
          <HiInformationCircle size={15} style={{ color: '#7C5CF6', flexShrink: 0 }} />
          <span style={{ fontSize: '12px', color: '#8B8FA8', fontWeight: 500, flex: 1 }}>
            Browser wallet — your seed phrase is your backup.{' '}
            <button
              onClick={() => navigate('/profile', { state: { openBackup: true } })}
              style={{ textDecoration: 'underline', background: 'none', border: 'none', color: '#7C5CF6', cursor: 'pointer', fontWeight: 700, fontSize: '12px' }}
            >
              Create account to sync across devices
            </button>
          </span>
        </div>
      )}

      {/* Strip 2: backed up but email not verified yet */}
      {isUnverified && (
        <EmailUnverifiedStrip email={wallet.email} />
      )}

      <main className="screen">
        {children}
      </main>

      <BottomNav />
    </div>
  );
}

function EmailUnverifiedStrip({ email }) {
  const [sending, setSending] = useState(false);

  const resend = async () => {
    setSending(true);
    try {
      await apiClient.post('/wallet/resend-verification', { email });
      toast.success('Verification email resent — check your inbox');
    } catch {
      toast.error('Could not resend — try again in a moment');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{
      background: 'rgba(98,116,241,0.08)',
      borderBottom: '1px solid rgba(98,116,241,0.2)',
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    }}>
      <HiEnvelope size={15} style={{ color: '#6274F1', flexShrink: 0 }} />
      <span style={{ fontSize: '12px', color: '#6274F1', fontWeight: 600, flex: 1 }}>
        Verify your email to secure wallet recovery.{' '}
        <button
          onClick={resend}
          disabled={sending}
          style={{ textDecoration: 'underline', background: 'none', border: 'none', color: '#6274F1', cursor: 'pointer', fontWeight: 700, fontSize: '12px', opacity: sending ? 0.5 : 1 }}
        >
          {sending ? 'Sending…' : 'Resend email'}
        </button>
      </span>
    </div>
  );
}
